import { apiPath } from "../constants/apiPath";

export const readCountryList = async () =>
  await fetch(apiPath.readCountryList, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({}),
  }).then((r) => r.json());

export const readNationalityList = async () =>
  await fetch(apiPath.readNationalityList, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({}),
  }).then((r) => r.json());

export const readGenderOption = async () =>
  await fetch(apiPath.readGenderOption, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({}),
  }).then((r) => r.json());

export const checkTourAndBoatAndDateAvailable = async ({
  id_tour_and_date,
  id_boat,
}) =>
  await fetch(apiPath.checkTourAndBoatAndDateAvailable, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({
      id_tour_and_date,
      id_boat,
    }),
  }).then((r) => r.json());

export const readTourAndBoatDetail = async ({ id_tour, id_boat }) =>
  await fetch(apiPath.readTourAndBoatDetail, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({
      id_tour,
      id_boat,
    }),
  }).then((r) => r.json());

export const onOcrPassport = async ({ replyToken, file }) => {
  const formData = new FormData();
  formData.append("replyToken", replyToken);
  formData.append("file", file); // ชื่อ field ต้องตรงกับที่ server ฝั่ง n8n รอรับ เช่น: "file"

  const tokenForOcrPassport =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE3NTAyMjIxNDB9.riZQQMyoPX5o7VffBfjGqUYkAcsUl2R2jbtP2FZfgwg";

  const res = await fetch("https://n8n.pkid.io/webhook/passport-id-ocr", {
    method: "POST",
    body: formData,
    headers: {
      authorization: `Baerer ${tokenForOcrPassport}`,
    },
  });

  const data = await res.json();
  return data;
};

export const deToken = async (token) =>
  await fetch(apiPath.deToken, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({ token }),
  }).then((r) => r.json());

export const submitPassenger = async (payload, token, { operationType }) =>
  await fetch(`${apiPath.submitPassenger}/?operationType=${operationType}`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      token,
    },
    body: JSON.stringify(payload),
  }).then((r) => r.json());

export const checkUpdateTranslation = async (payload, token) =>
  await fetch(apiPath.checkUpdateTranslation, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      token,
    },
    body: JSON.stringify(payload),
  }).then((r) => r.json());

export const translationJson = async (payload, token) =>
  await fetch(apiPath.translationJson, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      token,
    },
    body: JSON.stringify(payload),
  }).then((r) => r.json());

export const readPortAndTourByIdProject = async ({ id_project }) =>
  await fetch(`${apiPath.readPortAndTourByIdProject}/${id_project}`, {
    method: "GET",
    headers: {
      token: localStorage.getItem("login-token"),
    },
  }).then((r) => r.json());

export const login = async ({ id_project, password }) => {
  return await fetch(apiPath.login, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({ id_project, password }),
  }).then((r) => r.json());
};

export const checkCompanyExist = async ({ id_project }) => {
  return await fetch(`${apiPath.checkCompanyExist}/${id_project}`, {
    method: "GET",
  }).then((r) => r.json());
};
